// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1tfI1","left":"InfoRow_left__Lv5Bq"};